// extracted by mini-css-extract-plugin
export default {"container":"HeroSection_container__l4lg+","sideSection":"HeroSection_sideSection__u5D2H"};